@if (displayState) {
  <div class="content widget">
    <div class="component-header-row">
      <div class="widget-header">
        @if (displayState.view === 'ALL') {
          <span [innerHTML]="'widget.WIDGET_TITLE' | transloco:{value: 'widget.PERFORMING' | transloco}"></span>
        } @else {
          <span [innerHTML]="'widget.WIDGET_TITLE' | transloco:{value: ('contentType.' + displayState.view) | transloco}"></span>
        }
      </div>
    </div>
    <widget-top-captains-list class="widget-items" [data]="data"></widget-top-captains-list>
  </div>
}